export default {
  getAvatarImg: state => state.avatarImg,
  getLog: state => state.logo,
  metrics: state => state.metrics.data,
  metricsError: state => state.metrics.isError,
  metricsLoading: state => state.metrics.loading
}
